import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'




import login from '@/components/login'
import activity from '@/components/mode/activity'
import kefu from '@/components/mode/kefu'
import hongbao from '@/components/mode/hongbao'
import zhanzhu from '@/components/mode/zhanzhu'
import mine from '@/components/mode/mine'

import activityInfo from '@/components/mode/activityInfo'
import app from '@/components/app'
import gamePage from '@/components/gamePage'
import setting from '@/components/setting'
import userInfo from '@/components/userInfo'
import password from '@/components/password'
import wallet from '@/components/wallet'
import addBankCard from '@/components/addBankCard'
import addUsdtCard from '@/components/addUsdtCard'
import recharge from '@/components/recharge'
import payInfo from '@/components/payInfo'
import withdrawal from '@/components/withdrawal'
import transfer from '@/components/transfer'
import applyagent from '@/components/applyagent'
import message from '@/components/message'
import betRecord from '@/components/betRecord'
import transRecord from '@/components/transRecord'
import fanshui from '@/components/fanshui'
import activityRecord from '@/components/activityRecord'
import welfare from '@/components/welfare'
import vip from '@/components/vip'
import securitycenter from '@/components/securitycenter'
import boutBallBet from '@/components/boutBallBet'
import boutBallBetInfo from '@/components/boutBallBetInfo'
import concise from '@/components/concise'







Vue.use(Router)

export default new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/activity',
          name: 'activity',
          component: activity,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/kefu',
          name: 'kefu',
          component: kefu,

        }, {
          path: '/zhanzhu',
          name: 'zhanzhu',
          component: zhanzhu,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/mine',
          name: 'mine',
          component: mine,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }

      ]
    }, {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/app',
      name: 'app',
      component: app,
    },

    {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    },

    {
      path: '/setting',
      name: 'setting',
      component: setting,
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
    }, {
      path: '/password',
      name: 'password',
      component: password,
    }, {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
    }, {
      path: '/addBankCard',
      name: 'addBankCard',
      component: addBankCard,
    }, {
      path: '/addUsdtCard',
      name: 'addUsdtCard',
      component: addUsdtCard,
    }, {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,
    }, {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
    }
    , {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,

    },{
      path: '/applyagent',
      name: 'applyagent',
      component: applyagent,

    },{
      path: '/message',
      name: 'message',
      component: message,

    }
    ,{
      path: '/betRecord',
      name: 'betRecord',
      component: betRecord,

    }, {
      path: '/transRecord',
      name: 'transRecord',
      component: transRecord,

    },{
      path: '/fanshui',
      name: 'fanshui',
      component: fanshui,

    },{
      path: '/activityRecord',
      name: 'activityRecord',
      component: activityRecord,

    },{
      path: '/welfare',
      name: 'welfare',
      component: welfare,

    },{
      path: '/vip',
      name: 'vip',
      component: vip,

    },{
      path: '/securitycenter',
      name: 'securitycenter',
      component: securitycenter,

    },{
      path: '/boutBallBet',
      name: 'boutBallBet',
      component: boutBallBet,

    },{
      path: '/boutBallBetInfo',
      name: 'boutBallBetInfo',
      component: boutBallBetInfo,

    },{
      path: '/concise',
      name: 'concise',
      component: concise,

    },
    {
      path: '/hongbao',
      name: 'hongbao',
      component: hongbao,

    }


    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js